import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../shared/service/app.service';

import { SharedModule } from 'src/shared.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.html',
    standalone: true,
    imports: [SharedModule, CommonModule]
})
export class AuthLayout {
    store: any;
    showTopButton = false;
    constructor(public storeData: Store<any>, private service: AppService) {
        this.initStore();
    }
    headerClass = '';
    private scrollListener = () => {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            this.showTopButton = true;
        } else {
            this.showTopButton = false;
        }
    };

    ngOnInit() {
        this.toggleLoader();
        window.addEventListener('scroll', this.scrollListener);
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', this.scrollListener);
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
